const actions = {
  SET_STATE: 'appCore/SET_STATE',
  LIST: 'appCore/LIST',
  GET: 'appCore/GET',
  ADD: 'appCore/ADD',
  ADD_APP_ON_ONBOARDING: 'appCore/ADD_APP_ON_ONBOARDING',
  EDIT: 'appCore/EDIT',
  DELETE: 'appCore/DELETE',
  APPS_LIST: 'appCore/APPS_LIST',
  UPDATE_ACTIVE_APP: 'appCore/UPDATE_ACTIVE_APP',
  REMOVE_ACTIVE_APP: 'appCore/REMOVE_ACTIVE_APP',
  GET_APP_SETTINGS: 'appCore/GET_APP_SETTINGS',
  GET_APP_MESSAGE_SETTINGS: 'appCore/GET_APP_MESSAGE_SETTINGS',
  SAVE_APP_SETTINGS: 'appCore/SAVE_APP_SETTINGS',
  SAVE_APP_MESSAGE_SETTINGS: 'appCore/SAVE_APP_MESSAGE_SETTINGS',
  UPDATE_APP_STATE: 'appCore/UPDATE_APP_STATE',
  UPDATE_APP_SETTINGS: 'appCore/UPDATE_APP_SETTINGS',
  ENTER_APP_TEXT: 'appCore/ENTER_APP_TEXT',
  SEARCH_APP: 'appCore/SEARCH_APP',
  APP_MIGRATION_REQUEST_MANUAL_INTENT: 'appCore/APP_MIGRATION_REQUEST_MANUAL_INTENT',
  RESTORE_DELETED_APP_REQUEST: 'appCore/RESTORE_DELETED_APP_REQUEST',
  GTM_TRIGGERED_MANUAL_INTENT: 'appCore/GTM_TRIGGERED_MANUAL_INTENT',
}

export default actions
